import { EventBase } from "src/app/common/models/event/event-base";

// Can be used for Event listing
export class Event extends EventBase {
    note: string;
    description: string;    
}